import Vue from 'vue'

const state = {
  builds: {},
  buildItems: {}
}

const mutations = {
  SET_BUILDS (state, builds) {
    state.builds = builds
  },
  SET_BUILD_ITEMS (state, buildItems) {
    state.buildItems = buildItems
  },
  DELETE_BUILDS (state, buildIDS) {
    for (var id of buildIDS) {
      console.log('deleting ID: ' + id)
      Vue.delete(state.builds, id)
    }
  },
  ADD_BUILDS (state, builds) {
    for (var build of builds) {
      Vue.set(state.builds, build.id, build)
      // state.builds[build.id] = build
    }
  }
}

const actions = {
  fetchBuilds: ({commit}) => {
    /* return Vue.prototype.$axios.get('product-builds')
      .then(response => {
        commit('SET_BUILDS', response.data)
      }) */
      return
  },
  fetchBuildItems: ({commit}) => {
    /* return Vue.prototype.$axios.get('product-builds/build-items')
      .then(response => {
        commit('SET_BUILD_ITEMS', response.data)
      }) */
  },
  deleteBuilds: ({commit}, buildIDS) => {
    commit('DELETE_BUILDS', buildIDS)
  },
  addBuilds: ({commit}, builds) => {
    commit('ADD_BUILDS', builds)
  }
}

const getters = {
  getProductBuilds: state => invItemID => {
    return Object.values(state.builds).filter(item => {
      return item.inventory_item_id === invItemID
    })
  },
  getBuildItemByID: state => buildItemID => {
    return state.buildItems[buildItemID]
  },
  getBuildItems: state => buildID => {
    return Object.values(state.buildItems).filter(item => {
      return item.product_build_id === buildID
    })
  },
  getBuildsThatContainIngredient: state => invItemID => {
    return Object.values(state.buildItems).reduce((a, i) => {
      if (i.inventory_item_id === invItemID && !a.includes(i.product_build_id)) {
        a.push(state.builds[i.product_build_id])
      }
      return a
    }, [])
  },
  getBuildsItemsOfType: state => invItemID => {
    return Object.values(state.buildItems).filter(item => {
      return item.inventory_item_id === invItemID
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
